import './send-parts-order.modal.scss';

export default function SendPartsOrderModal($scope, $t, close, $alert) {
  'ngInject';

  $scope.emailInfo = {};

  $scope.ok = (form) => {
    if (!$scope.emailInfo.recipient) {
      $alert.error($t('shared.modals.send_parts_order.recipient_required_error'));
      return;
    }

    if (form.$valid) {
      const result = {
        recipient: $scope.emailInfo.recipient,
        cc: $scope.emailInfo.cc ? $scope.emailInfo.cc.split(",").map(email => email.trim()) : undefined
      };

      close(result);
    }
  }

  $scope.close = () => {
    close(false);
  }
}